import { Component, OnInit } from '@angular/core';
import { ComponentServiceBundle } from '@app/core/services/base/component-service-bundle.service';
import { BaseWithBundleComponent } from '@app/shared/components/base/base-with-bundle.component';
import { ClaimTypeService, ClaimTypeUriBuilderParams } from '@app/core/services/claim-type.service';
import { BaseWithIdList } from '@app/shared/models/list';
import { ClaimType } from '@app/shared/models/claim-type';
import { FileType, FileTypes } from '@app/shared/models/file-type';
import {
    DrFileMeta,
    DrFileMetaCategoryList,
    DrFileMetaProperties,
    FileUploadStatus
} from '@app/shared/models/dr-file';
import * as _ from 'lodash-es';
import { FileUtilityService } from '@app/core/services/file-utility.service';
import { ContentStoreService } from '@app/core/services/content-store.service';

@Component({
    selector: 'work-instructions',
    templateUrl:  './work-instructions.component.html',
    styleUrls:  ['./work-instructions.component.scss']
})
export class WorkInstructionsComponent extends BaseWithBundleComponent
                                       implements OnInit {

    public claimTypesList: BaseWithIdList<ClaimType>;
    public acceptedFileTypes: FileType[];
    public fileMetaCategoryList: DrFileMetaCategoryList;

    constructor(protected componentServiceBundle:  ComponentServiceBundle,
                protected claimTypeService: ClaimTypeService,
                protected fileUtilityService: FileUtilityService,
                protected contentStoreService: ContentStoreService) {
        super(componentServiceBundle);
        this._idPrefix = 'work-instructions.';
        this.acceptedFileTypes = [FileTypes.PDF];
    }

    public ngOnInit() {
        super.ngOnInit();
        this.claimTypeService.query(new ClaimTypeUriBuilderParams())
                             .subscribe((result) => {
            this.claimTypesList = result;
            this.fileMetaCategoryList = new DrFileMetaCategoryList();
            this.claimTypesList.items.forEach((claimType) => {
                this.fileMetaCategoryList.addItem(claimType.instructions);
            });
         });
    }

    public onFilesSelected(files: File[], claimType: ClaimType): void {
        if (files) {
            _.each(files, (file: File) => {
                const newFileMeta = new DrFileMeta();
                newFileMeta.filename = file.name;
                newFileMeta.properties = new DrFileMetaProperties({ smp_category: claimType.id });
                newFileMeta.status = FileUploadStatus.LOADING;
                newFileMeta.order = this.fileMetaCategoryList.getNextOrderForCategory(claimType.id);
                newFileMeta.document_type = claimType.id;

                this.fileMetaCategoryList.addFileMeta(newFileMeta);

                this.fileUtilityService.fileAsBinaryString(file)
                                       .subscribe((fileAsBinaryString) => {
                        this.contentStoreService.addWorkInstructionFile(claimType, fileAsBinaryString, newFileMeta)
                                                .subscribe((result: DrFileMeta) => {
                                result.status = FileUploadStatus.READY;
                                this.fileMetaCategoryList.replaceFileMetaAfterUpload(result);
                            },
                            err => {
                                newFileMeta.status = FileUploadStatus.ERROR;
                                this.fileMetaCategoryList.replaceFileMetaAfterUpload(newFileMeta);
                            }
                        );
                    });
            });
        }
    }

    public viewFile(drFileMeta: DrFileMeta): void {
        this.fileUtilityService.viewFileInNewTab(drFileMeta);
    }

    public downloadFile(drFileMeta: DrFileMeta): void {
        this.fileUtilityService.downloadFile(drFileMeta);
    }

    public deleteFile(claimType: ClaimType, drFileMeta: DrFileMeta): void {
        this.contentStoreService.deleteWorkInstructionFile(claimType, drFileMeta)
                                .subscribe(result => {
                const reorderedFilePatchList = this.fileMetaCategoryList.getFilesByCategory(claimType.id).removeFileMetaData(drFileMeta);

                if (reorderedFilePatchList && reorderedFilePatchList.length > 0) {
                    this.contentStoreService.reorderWorkInstructionMeta(claimType, reorderedFilePatchList)
                        .subscribe(patchResult => {
                            this.fileMetaCategoryList.updateFileMetaOrderAfterSuccessFullPatch(reorderedFilePatchList);
                            // this.fileMetaCategoryList.getFilesByCategory(claimType.id).(reorderedFilePatchList);
                        }, err => this.handleError(err));
                }
            }, err => this.handleError(err));
    }
}
